/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendUserTypingRequest} from '@cash-web/protos/squareup/cash/supportal/app.pb'
import {SendUserTypingResponse} from '@cash-web/protos/squareup/cash/supportal/app.pb'


export const sendUserTyping = (request: SendUserTypingRequest, options?: CashRequestOptions) => post<SendUserTypingRequest, SendUserTypingResponse>("/2.0/cash/send-user-typing", request, {...options, rejectOnError: true })